var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveItemGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b1b1b1;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "RemoveItemGrey") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_2",
    "data-name": "Lager 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Topp"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Folksam"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17,
    cy: 17,
    r: 17
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_Smart_Object_Bild",
    "data-name": "Vector Smart Object\\xA0Bild"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Vector_Smart_Object_Bild-2",
    "data-name": "Vector Smart Object\\xA0Bild",
    width: 16,
    height: 16,
    transform: "translate(9 9)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAAAa0lEQVQ4T2P4////NSA+D8SiQMxAJBaF6rnGAGWAwGUiDRGFqgWB8+gChAzBUItTghjNIHGCCgjJEWMLXtcR8ud1KMaqGZcBMENgGmEGYQ1cmhhAkRcoCkSKopGihESMZpyGgAQpzkwUZWcAh/pOghluJ88AAAAASUVORK5CYII="
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveItemGrey);
export default __webpack_public_path__ + "static/media/RemoveItemGrey.e9e67e0deebe213e1ffc10e84d8f1d84.svg";
export { ForwardRef as ReactComponent };